<template>
    <div class="cms-container">
        <div v-if="showSystemBackupModal"
            class="modal-overlay d-flex align-items-center justify-content-center fixed-top w-100 h-100 left-0"
            @mousedown="onOverlayMouseDown" @mouseup="onOverlayMouseUp">
            <ToastCMS ref="toast" />
            <div class="modal-content bg-white overflow-hidden">
                <div class="modal-header d-flex justify-content-between align-items-center px-3 py-3">
                    <h2 class="m-0 text-dark">System Backup</h2>
                    <button class="text-dark bg-transparent border-0 material-symbols-outlined"
                        @click="closeModals">close</button>
                </div>
                <p class=" text-dark my-2 px-3 py-2" style="font-size: 0.9rem;">
                    Automated persistence is active. The server automatically saves changes to its internal disk.
                    Rebooting will no longer wipe your data.
                </p>
                <div class="w-100 px-3 py-2">
                    <div class="p-3 border rounded bg-light">
                        <div class="text-dark font-weight-bold">Export Data</div>
                        <p class="small text-muted">Download all CMS categories, news, and settings into a single backup
                            file.</p>
                        <button @click="exportData" style="gap:5px;"
                            class="vmc-bg-prime-4 text-white border-0 py-2 px-4 rounded w-100 d-flex align-items-center justify-content-center">
                            <i class="material-symbols-outlined text-white">download</i>
                            Download Backup (.json)
                        </button>
                    </div>
                </div>
                <div class="w-100 px-3 py-2">
                    <div class="p-3 border rounded bg-light">
                        <div class="text-dark font-weight-bold">Restore Data</div>
                        <p class="small text-muted">Upload a previously saved backup file to restore the website
                            content.</p>

                        <input type="file" ref="fileInput" accept=".json" hidden @change="handleImport">

                        <button @click="$refs.fileInput.click()" style="gap:5px;"
                            class="vmc-bg-prime-5 text-white border-0 py-2 px-4 rounded w-100 d-flex align-items-center justify-content-center">
                            <i class="material-symbols-outlined text-white">upload</i>
                            Upload & Restore
                        </button>
                    </div>
                </div>
                <div class="pb-3 px-3">
                    <div class="mt-4 p-3 bg-warning-subtle border border-warning rounded">
                        <p class="mb-0 text-dark" style="font-size: 0.85rem;">
                            <strong class="text-dark">Note:</strong> Auto-save is running. Manual backups are still
                            recommended. You
                            <strong class="text-dark">should</strong> use the "Upload & Restore" button only if you need
                            to roll back to an older version.
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <nav class="vmc-sidebar vh-100 text-white fixed-top left-0 d-hidden d-xl-flex flex-column overflow-hidden">
            <header class="d-lg-flex justify-content-center align-items-center p-2"
                style="background-color:var(--vmc-primary-5)">
                <img :src="vmcLogo" alt="" style="width: 70px;">
            </header>
            <div class="vmc-sidebar-lists">
                <ul class="m-0 p-0">
                    <li>
                        <router-link to="/admin/dashboard"
                            :class="['vmc-lists w-100 d-flex align-items-center px-2 py-3 border-0 text-decoration-none', { 'active-link': isActive('/admin/dashboard') }]">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="#ffffff" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round">
                                <rect width="7" height="9" x="3" y="3" rx="1" />
                                <rect width="7" height="5" x="14" y="3" rx="1" />
                                <rect width="7" height="9" x="14" y="12" rx="1" />
                                <rect width="7" height="5" x="3" y="16" rx="1" />
                            </svg>
                            Dashboard
                        </router-link>
                    </li>
                    <li>
                        <button :class="[
                            'vmc-lists w-100 d-flex align-items-center px-2 py-3 border-0 text-decoration-none bg-transparent',
                            { 'active-link': isParentActive(homeLinks) }]" @click="toggle('home')">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="#ffffff" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round">
                                <path d="M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8" />
                                <path
                                    d="M3 10a2 2 0 0 1 .709-1.528l7-6a2 2 0 0 1 2.582 0l7 6A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                            </svg>
                            <span class="mr-auto">Home</span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="#ffffff" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="lucide lucide-chevron-down-icon lucide-chevron-down"
                                :class="{ 'rotate': open.home }">
                                <path d="m6 9 6 6 6-6" />
                            </svg>
                        </button>
                        <ul class="vmc-dropdown-menu" :class="{ 'dropdown-open': open.home }">
                            <li class="list-unstyled">
                                <router-link to="/admin/key-visuals"
                                    :class="['w-100 d-flex align-items-center text-decoration-none', { 'active-link': isActive('/admin/key-visuals') }]">
                                    Key Visuals
                                </router-link>
                            </li>
                            <li class="list-unstyled">
                                <router-link to="/admin/job-hiring"
                                    :class="['w-100 d-flex align-items-center text-decoration-none', { 'active-link': isActive('/admin/job-hiring') }]">
                                    Job Hiring
                                </router-link>
                            </li>
                            <li class="list-unstyled">
                                <router-link to="/admin/crew-and-fleet"
                                    :class="['w-100 d-flex align-items-center text-decoration-none', { 'active-link': isActive('/admin/crew-and-fleet') }]">
                                    Crew and Fleet Status
                                </router-link>
                            </li>
                            <li class="list-unstyled">
                                <router-link to="/admin/membership-affiliations"
                                    :class="['w-100 d-flex align-items-center text-decoration-none', { 'active-link': isActive('/admin/membership-affiliations') }]">
                                    Membership and Affiliations
                                </router-link>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <button :class="[
                            'vmc-lists w-100 d-flex align-items-center px-2 py-3 border-0 text-decoration-none bg-transparent',
                            { 'active-link': isParentActive(aboutUsLinks) }]" @click="toggle('about')">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="#ffffff" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round">
                                <circle cx="12" cy="12" r="10" />
                                <path d="M12 16v-4" />
                                <path d="M12 8h.01" />
                            </svg>
                            <span class="mr-auto">About Us</span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="#ffffff" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="lucide lucide-chevron-down-icon lucide-chevron-down"
                                :class="{ 'rotate': open.about }">
                                <path d="m6 9 6 6 6-6" />
                            </svg>
                        </button>
                        <ul class="vmc-dropdown-menu" :class="{ 'dropdown-open': open.about }">
                            <li class="list-unstyled">
                                <router-link to="/admin/the-company"
                                    :class="['w-100 d-flex align-items-center text-decoration-none', { 'active-link': isActive('/admin/the-company') }]">
                                    The Company
                                </router-link>
                            </li>
                            <li class="list-unstyled">
                                <router-link to="/admin/our-principals"
                                    :class="['w-100 d-flex align-items-center text-decoration-none', { 'active-link': isActive('/admin/our-principals') }]">
                                    Our Principals
                                </router-link>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <button :class="[
                            'vmc-lists w-100 d-flex align-items-center px-2 py-3 border-0 text-decoration-none bg-transparent',
                            { 'active-link': isParentActive(newsLinks) }]" @click="toggle('news')">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="#ffffff" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round">
                                <path d="M15 18h-5" />
                                <path d="M18 14h-8" />
                                <path
                                    d="M4 22h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16a2 2 0 0 1-4 0v-9a2 2 0 0 1 2-2h2" />
                                <rect width="8" height="4" x="10" y="6" rx="1" />
                            </svg>
                            <span class="mr-auto">News</span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="#ffffff" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="lucide lucide-chevron-down-icon lucide-chevron-down"
                                :class="{ 'rotate': open.news }">
                                <path d="m6 9 6 6 6-6" />
                            </svg>
                        </button>
                        <ul class="vmc-dropdown-menu" :class="{ 'dropdown-open': open.news }">
                            <li class="list-unstyled">
                                <router-link to="/admin/news"
                                    :class="['w-100 d-flex align-items-center text-decoration-none', { 'active-link': isActive('/admin/news') }]">
                                    News Article
                                </router-link>
                            </li>
                            <li class="list-unstyled">
                                <router-link to="/admin/news-history"
                                    :class="['w-100 d-flex align-items-center text-decoration-none', { 'active-link': isActive('/admin/news-history') }]">
                                    News History
                                </router-link>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <button :class="[
                            'vmc-lists w-100 d-flex align-items-center px-2 py-3 border-0 text-decoration-none bg-transparent',
                            { 'active-link': isParentActive(companyLinks) }]" @click="toggle('company')">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="#ffffff" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round">
                                <path d="M10 12h4" />
                                <path d="M10 8h4" />
                                <path d="M14 21v-3a2 2 0 0 0-4 0v3" />
                                <path d="M6 10H4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-2" />
                                <path d="M6 21V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v16" />
                            </svg>
                            <span class="mr-auto">Company</span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="#ffffff" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="lucide lucide-chevron-down-icon lucide-chevron-down"
                                :class="{ 'rotate': open.company }">
                                <path d="m6 9 6 6 6-6" />
                            </svg>
                        </button>
                        <ul class="vmc-dropdown-menu" :class="{ 'dropdown-open': open.company }">
                            <li class="list-unstyled">
                                <router-link to="/admin/csr-activities"
                                    :class="['w-100 d-flex align-items-center text-decoration-none', { 'active-link': isActive('/admin/csr-activities') }]">
                                    CSR Activities
                                </router-link>
                            </li>
                            <li class="list-unstyled">
                                <router-link to="/admin/office-programs"
                                    :class="['w-100 d-flex align-items-center text-decoration-none', { 'active-link': isActive('/admin/office-programs') }]">
                                    Office Programs
                                </router-link>
                            </li>
                            <li class="list-unstyled">
                                <router-link to="/admin/allottees"
                                    :class="['w-100 d-flex align-items-center text-decoration-none', { 'active-link': isActive('/admin/allottees') }]">
                                    Allottees
                                </router-link>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <button :class="[
                            'vmc-lists w-100 d-flex align-items-center px-2 py-3 border-0 text-decoration-none bg-transparent',
                            { 'active-link': isParentActive(crewLinks) }]" @click="toggle('crew')">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="#ffffff" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round">
                                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                <path d="M16 3.128a4 4 0 0 1 0 7.744" />
                                <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                                <circle cx="9" cy="7" r="4" />
                            </svg>
                            <span class="mr-auto">Crew</span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="#ffffff" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="lucide lucide-chevron-down-icon lucide-chevron-down"
                                :class="{ 'rotate': open.crew }">
                                <path d="m6 9 6 6 6-6" />
                            </svg>
                        </button>
                        <ul class="vmc-dropdown-menu" :class="{ 'dropdown-open': open.crew }">
                            <li class="list-unstyled">
                                <router-link to="/admin/scholarship-cadetship"
                                    :class="['w-100 d-flex align-items-center text-decoration-none', { 'active-link': isActive('/admin/scholarship-cadetship') }]">
                                    Scholarship and Cadetship
                                </router-link>
                            </li>
                            <li class="list-unstyled">
                                <router-link to="/admin/crew-development"
                                    :class="['w-100 d-flex align-items-center text-decoration-none', { 'active-link': isActive('/admin/crew-development') }]">
                                    Crew Development
                                </router-link>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <router-link to="/admin/schedules"
                            :class="['vmc-lists w-100 d-flex align-items-center px-2 py-3 border-0 text-decoration-none', { 'active-link': isActive('/admin/schedules') }]">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="#ffffff" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round">
                                <path d="M16 14v2.2l1.6 1" />
                                <path d="M16 4h2a2 2 0 0 1 2 2v.832" />
                                <path d="M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h2" />
                                <circle cx="16" cy="16" r="6" />
                                <rect x="8" y="2" width="8" height="4" rx="1" />
                            </svg>
                            Schedules
                        </router-link>
                    </li>
                    <li>
                        <router-link to="/admin/careers"
                            :class="['vmc-lists w-100 d-flex align-items-center px-2 py-3 border-0 text-decoration-none', { 'active-link': isActive('/admin/careers') }]">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="#ffffff" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round">
                                <path d="M12 12h.01" />
                                <path d="M16 6V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" />
                                <path d="M22 13a18.15 18.15 0 0 1-20 0" />
                                <rect width="20" height="14" x="2" y="6" rx="2" />
                            </svg>
                            Career
                        </router-link>
                    </li>
                    <li>
                        <router-link to="/admin/contact-us"
                            :class="['vmc-lists w-100 d-flex align-items-center px-2 py-3 border-0 text-decoration-none', { 'active-link': isActive('/admin/contact-us') }]">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="#ffffff" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round">
                                <path
                                    d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384" />
                            </svg>
                            Contacts
                        </router-link>
                    </li>
                    <li>
                        <router-link to="/admin/users-lists"
                            :class="['vmc-lists w-100 d-flex align-items-center px-2 py-3 border-0 text-decoration-none', { 'active-link': isActive('/admin/users-lists') }]">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="#ffffff" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round"
                                class="lucide lucide-user-round-plus-icon lucide-user-round-plus">
                                <path d="M2 21a8 8 0 0 1 13.292-6" />
                                <circle cx="10" cy="8" r="5" />
                                <path d="M19 16v6" />
                                <path d="M22 19h-6" />
                            </svg>
                            Users Lists
                        </router-link>
                    </li>
                    <li>
                        <button @click="openModal('systembackup')"
                            class="vmc-lists w-100 d-flex align-items-center px-2 py-3 border-0 text-decoration-none bg-transparent">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="#ffffff" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round"
                                class="lucide lucide-archive-restore-icon lucide-archive-restore">
                                <rect width="20" height="5" x="2" y="3" rx="1" />
                                <path d="M4 8v11a2 2 0 0 0 2 2h2" />
                                <path d="M20 8v11a2 2 0 0 1-2 2h-2" />
                                <path d="m9 15 3-3 3 3" />
                                <path d="M12 12v9" />
                            </svg>
                            <span class="mr-auto">System Backup</span>
                        </button>
                    </li>
                </ul>
            </div>
            <footer class="vmc-footer d-flex align-items-center px-3 py-3">
                <img :src="profile" alt="" class="vmc-profile-picture rounded-circle mr-2">
                <div>
                    <div class="account-name text-nowrap">{{ accountName }}</div>
                    <div class="role-type text-nowrap">{{ userRole }}</div>
                </div>
            </footer>
        </nav>
    </div>
</template>

<script>
import ToastCMS from './ToastCMS.vue';
export default {
    name: "VMCSidebarCMS",
    components: { ToastCMS },
    data() {
        return {
            vmcLogo: require("@/assets/veritas_logo.png"),
            profile: require("@/assets/profile-white.png"),
            overlayMouseDownOnOverlay: false,
            showSystemBackupModal: false,
            isOpen: false,
            open: {
                home: false,
                about: false,
                news: false,
                company: false,
                crew: false,
            },
            homeLinks: [
                { path: '/admin/key-visuals' },
                { path: '/admin/job-hiring' },
                { path: '/admin/crew-and-fleet' },
                { path: '/admin/membership-affiliations' }
            ],
            aboutUsLinks: [
                { path: '/admin/the-company' },
                { path: '/admin/our-principals' },
            ],
            newsLinks: [
                { path: '/admin/news' },
                { path: '/admin/news-history' }
            ],
            crewLinks: [
                { path: '/admin/scholarship-cadetship' },
                { path: '/admin/crew-development' }
            ],
            companyLinks: [
                { path: '/admin/csr-activities' },
                { path: '/admin/office-programs' },
                { path: '/admin/allottees' }
            ],
            accountName: localStorage.getItem('vmc_user') || 'Account Full Name',
            userRole: localStorage.getItem('vmc_role') || 'Admin',
            isAdmin: localStorage.getItem('vmc_role') === 'Admin',
        }
    },
    mounted() {
        window.addEventListener('keydown', this.onKeyboard);
        this.openActiveDropdown();
        this.loadProfile();
        window.addEventListener('profile-updated', this.loadProfile);
    },
    beforeDestroy() {
        window.removeEventListener('keydown', this.onKeyboard);
        window.removeEventListener('profile-updated', this.loadProfile);
    },
    watch: {
        $route() {
            this.openActiveDropdown();
        }
    },
    methods: {
        async exportData() {
            try {
                const response = await fetch(`${process.env.VUE_APP_API_URL}/api/content?_nocache=${new Date().getTime()}`);
                const data = await response.json();

                // Create a blob and download it
                const fileName = `VMC_Backup_${new Date().toISOString().slice(0, 10)}.json`;
                const json = JSON.stringify(data, null, 2);
                const blob = new Blob([json], { type: 'application/json' });
                const href = URL.createObjectURL(blob);

                const link = document.createElement('a');
                link.href = href;
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(href);

                this.$refs.toast.showToast("Backup downloaded successfully.", "success");
            } catch (error) {
                this.$refs.toast.showToast("Failed to export data.", "error");
            }
        },

        handleImport(event) {
            const file = event.target.files[0];
            if (!file) return;

            const reader = new FileReader();
            reader.onload = async (e) => {
                try {
                    const importedData = JSON.parse(e.target.result);

                    // Basic validation to ensure it's a VMC backup
                    if (!importedData.newsArticles) {
                        throw new Error("Invalid backup format.");
                    }

                    const token = localStorage.getItem('vmc_token');
                    const response = await fetch(`${process.env.VUE_APP_API_URL}/api/update`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`
                        },
                        body: JSON.stringify(importedData)
                    });

                    if (response.ok) {
                        this.$refs.toast.showToast("Data restored. Reloading...", "success");
                        setTimeout(() => window.location.reload(), 2000);
                    } else {
                        this.$refs.toast.showToast("Server rejected the restore.", "error");
                    }
                } catch (err) {
                    this.$refs.toast.showToast("Error: " + err.message, "error");
                }
            };
            reader.readAsText(file);
            event.target.value = ''; // Reset input
        },

        loadProfile() {
            const savedImage = localStorage.getItem(`vmc_profile_${this.accountName}`);
            this.profile = savedImage ? savedImage : require("@/assets/profile-white.png");
        },
        toggle(menu) {
            Object.keys(this.open).forEach(key => {
                this.open[key] = key === menu ? !this.open[key] : false;
            });
        },
        isActive(path) {
            return this.$route.path === path;
        },
        isParentActive(links) {
            return links.some(link => this.isActive(link.path));
        },
        openActiveDropdown() {
            const menuMap = {
                home: this.homeLinks,
                about: this.aboutUsLinks,
                news: this.newsLinks,
                company: this.companyLinks,
                crew: this.crewLinks,
            };
            Object.keys(menuMap).forEach(key => {
                this.open[key] = menuMap[key].some(link => link.path === this.$route.path);
            });
        },
        openModal(type) {
            if (type === 'systembackup') this.showSystemBackupModal = true;
        },

        closeModals() {
            this.showSystemBackupModal = false;
        },

        onKeyboard(e) {
            if (this.showSystemBackupModal) {
                if (e.key === 'Escape') this.closeModals();
            }
        },

        onOverlayMouseDown(e) {
            this.overlayMouseDownOnOverlay = e.target.classList.contains('modal-overlay');
        },

        onOverlayMouseUp(e) {
            if (this.overlayMouseDownOnOverlay && e.target.classList.contains('modal-overlay')) {
                this.closeModals();
            }
            this.overlayMouseDownOnOverlay = false;
        },
    }
}
</script>

<style scoped>
.toast-container {
    position: fixed;
    width: 300px;
    top: 20px;
    right: 20px;
    z-index: 9999;
}

::-webkit-scrollbar {
    width: 4px;
    height: 4px;
}

::-webkit-scrollbar-thumb {
    background-color: #666;
}

.vmc-dropdown-menu {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s ease, opacity 0.3s ease;
    opacity: 0;
}

.vmc-dropdown-menu.dropdown-open {
    max-height: 300px;
    opacity: 1;
}

@media (min-width: 330px) {
    .modal-overlay {
        background-color: rgba(0, 0, 0, 0.5);
        z-index: 9999;
        overflow-y: auto;
        overscroll-behavior: contain;
    }

    .modal-content {
        border-radius: 8px;
        width: 400px;
        max-width: 90%;
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
        animation: slideDown 0.3s ease-out;
    }

    .modal-header {
        background-color: #f5f5f5;
        border-bottom: 1px solid #ddd;
    }

    .modal-header h2 {
        font-size: 1.2rem;
    }

    .modal-body {
        padding: 20px;
    }

    @keyframes slideDown {
        from {
            transform: translateY(-20px);
            opacity: 0;
        }

        to {
            transform: translateY(0);
            opacity: 1;
        }
    }

    .vmc-sidebar {
        display: none;
    }
}

@media (min-width: 1200px) {
    header {
        overflow: hidden;
        overscroll-behavior: contain;
        border-bottom: 1px solid #666;
        flex-shrink: 0;
    }

    .vmc-sidebar {
        width: 310px;
        background-color: var(--vmc-primary-5);
    }

    .vmc-sidebar-lists {
        overflow-y: auto;
        overscroll-behavior: contain;
        flex: 1;
    }

    .vmc-sidebar-lists .vmc-lists,
    .vmc-sidebar-lists .vmc-lists i,
    .vmc-sidebar-lists .vmc-lists span,
    .vmc-sidebar-lists .vmc-lists svg {
        gap: 12px;
        cursor: pointer;
        color: #fff;
        transition: 0.3s;
    }

    .vmc-sidebar-lists .vmc-lists:hover,
    .vmc-sidebar-lists .vmc-lists:hover i,
    .vmc-sidebar-lists .vmc-lists:hover span,
    .vmc-sidebar-lists .vmc-lists:hover svg {
        color: var(--vmc-primary-3);
        stroke: var(--vmc-primary-3);
    }

    .rotate {
        transform: rotate(180deg);
        transition: transform 0.2s ease;
    }

    .vmc-dropdown-menu li {
        padding: 0 0 15px 12px;
    }

    .vmc-dropdown-menu li,
    .vmc-dropdown-menu a {
        color: #fff;
        transition: 0.3s;
    }

    .vmc-dropdown-menu li:hover,
    .vmc-dropdown-menu a:hover {
        color: var(--vmc-primary-3);
    }

    footer {
        border-top: 1px solid #666;
        padding: 15px 20px;
        overflow: hidden;
        overscroll-behavior: contain;
        flex-shrink: 0;
    }

    footer i,
    footer div,
    span {
        color: #fff;
    }

    .vmc-profile-picture {
        height: 45px;
        width: 45px;
        object-fit: cover;
    }

    .account-name {
        font-size: 16px;
    }

    .role-type {
        font-size: 14px;
    }

    .active-link,
    .active-link i,
    .active-link span,
    .active-link svg {
        color: var(--vmc-primary-3) !important;
        stroke: var(--vmc-primary-3) !important;
    }
}
</style>